import React from "react";
import "./styles.css";
import NavBar from "../../components/YourStylist/NavBar";
const Policy = () => {
  return (
    <div className="yourstylist md:mt-[150px]">
      <NavBar />
      <div className="w-[93vw] my-3 mx-auto flex flex-col gap-4">
        <h1 className=" text-5xl ">Delivery Policy </h1>
        <p className="text-3xl">Next Day Delivery – How does it work? </p>
        <div className="flex">
          Inside Yangon: Your order will be delivered to the given address
          within 2 to 3 days.
        </div>
        <div className="flex">
          Mandalay : Your order will be delivered to the given address within 3-
          5 days.{" "}
        </div>
        <div className="flex">
          Other Big Cities : Your order will be delivered to the given address
          within 3- 7 days.{" "}
        </div>{" "}
        <div className="flex flex-col gap-4">
          <p className="text-3xl">Payment Policy </p>
          <div className="flex">
            {" "}
            Cash on Delivery System : Only available for Yangon, Mandalay,
            Naypyitaw, Taunggyi, Bago and Mawlamyine.
          </div>
          <div className="flex">
            Prepaid System : Other cities need to transfer money to ahead before
            order get received.
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <p className="text-3xl">Online Payment Policy </p>
          <div className="flex">
            {" "}
            We accept KBZ pay, KBZ bank, Wave Pay, AYA pay.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
